module.exports = __webpack_public_path__ + "static/media/icon_load-error.12152f41.svg";